import { ArrowLeftRight, Mail, Users, UserPlus, UserCog } from 'lucide-react'
import {
  primaryEntityActionButtonClass,
  secondaryEntityActionButtonClass,
} from '@/components/ui/entityActionButtonClasses'
import { cn } from '@/lib/utils/helpers'
import type { PropertyContactsToolbarProps } from '../types'

/** Matches company Contacts tab “Contact Actions” bar layout. */
export function PropertyContactsToolbar({
  showSelectBox,
  composeDisabled,
  onTransfer,
  onToggleEmailMode,
  onUserManagement,
  onAddUser,
  onCancelEmail,
  onCompose,
}: PropertyContactsToolbarProps) {
  return (
    <section
      data-testid="property-contacts-section-actions"
      className="rounded-xl border border-slate-200 bg-white px-4 py-3 shadow-[0_4px_12px_rgba(15,23,42,0.05),0_1px_2px_rgba(15,23,42,0.04)] sm:px-5"
    >
      <div className="flex flex-col gap-3 lg:flex-row lg:items-center">
        <div className="flex shrink-0 items-center gap-2.5 lg:pr-4">
          <span className="inline-flex h-8 w-8 shrink-0 items-center justify-center rounded-lg border border-[#c7ddff] bg-[#dbeafe] text-[rgb(21_151_255)]">
            <UserCog className="h-4 w-4" aria-hidden />
          </span>
          <h2
            data-testid="property-contacts-section-actions-title"
            className="whitespace-nowrap text-base font-bold tracking-tight text-slate-900"
          >
            Contact Actions
          </h2>
        </div>

        <div className="hidden h-9 w-px shrink-0 bg-slate-200 lg:block" aria-hidden />

        <div className="flex w-full flex-1 flex-wrap items-center gap-2.5 lg:pl-4">
          <button
            type="button"
            onClick={onTransfer}
            data-testid="property-contacts-transfer-button"
            className={cn(primaryEntityActionButtonClass, 'gap-2')}
          >
            <ArrowLeftRight className="h-4 w-4 shrink-0" aria-hidden />
            Transfer
          </button>
          <button
            type="button"
            onClick={onToggleEmailMode}
            data-testid="property-contacts-email-button"
            className={cn(primaryEntityActionButtonClass, 'gap-2')}
          >
            <Mail className="h-4 w-4 shrink-0" aria-hidden />
            Email
          </button>
          <button
            type="button"
            onClick={onUserManagement}
            data-testid="property-contacts-user-mgmt-button"
            className={cn(primaryEntityActionButtonClass, 'gap-2 whitespace-nowrap')}
          >
            <Users className="h-4 w-4 shrink-0" aria-hidden />
            User Management
          </button>
          <button
            type="button"
            onClick={onAddUser}
            data-testid="property-contacts-add-user-button"
            className={cn(primaryEntityActionButtonClass, 'gap-2 whitespace-nowrap')}
          >
            <UserPlus className="h-4 w-4 shrink-0" aria-hidden />
            Add User
          </button>
        </div>
      </div>

      {showSelectBox ? (
        <div className="mt-3 flex flex-wrap items-center justify-end gap-2.5 border-t border-slate-100 pt-3">
          <button
            type="button"
            onClick={onCompose}
            disabled={composeDisabled}
            data-testid="property-contacts-compose-button"
            className={cn(primaryEntityActionButtonClass, 'gap-2')}
          >
            <Mail className="h-4 w-4" aria-hidden />
            Compose
          </button>
          <button
            type="button"
            onClick={onCancelEmail}
            data-testid="property-contacts-cancel-email-button"
            className={secondaryEntityActionButtonClass}
          >
            Cancel
          </button>
        </div>
      ) : null}
    </section>
  )
}
